// extracted by mini-css-extract-plugin
export default {"filterSummary":"VyFpkRf","foundCount":"doxS_Ku"};